<template>
  <div class="tools-background">
    <div class="tools-container">
      <CellTypeDropDown :label="selectedLabel || 'Select RBC Type'" />
      <div class="tools-actions">
        <MeasurementRulerToggle
          v-if="rulerAvailable && taskId"
          :task-id="taskId"
        />
        <ReportReviewTiny class="title column" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CellTypeDropDown from "./CellTypeDropDown.vue";
import ReportReviewTiny from "../../components/ReportReviewTiny.vue";
import MeasurementRulerToggle from "@/components/measurement/MeasurementRulerToggle.vue";

defineProps<{
  selectedLabel?: string;
  taskId?: string;
  rulerAvailable?: boolean;
}>();
</script>

<style lang="scss" scoped>
@use "@/assets/scss/common/alignment" as *;

.title {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #212121;
  display: flex;
  align-items: center;
  margin: 0 8px;
}

.tools-background {
  position: sticky;
  display: flex;
  top: 70px;
  width: 100%;
  padding: 10px;
  background: rgb(238, 238, 238);
  z-index: 10;
  border-bottom: 1px solid #ddd;
  box-sizing: border-box;
  overflow-x: auto;
}

.tools-container {
  width: 100%;
  display: flex;
  justify-content: space-between;  
  gap: 16px;
  min-width: max-content;
}

.tools-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
  flex-shrink: 0;
}
</style>
